import { render, staticRenderFns } from "./KnowYourCustomer.vue?vue&type=template&id=2d1d2bfa&scoped=true"
import script from "./KnowYourCustomer.vue?vue&type=script&lang=js"
export * from "./KnowYourCustomer.vue?vue&type=script&lang=js"
import style0 from "./KnowYourCustomer.vue?vue&type=style&index=0&id=2d1d2bfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1d2bfa",
  null
  
)

export default component.exports